<template>


    <div class="lp-page-content">
        <div class="lp-content">
            <h1 class="head-first"> Welcome to the AI Grid Platform</h1>
            <h2 class="head-sec">This is the place where smart collaborations in AI arise!</h2>
            <h3 class="head-third">Students and young researchers in AI: broaden your horizons and give your career a boost!</h3>
            <h4>You are currently working on your master thesis or doctoral dissertation on a topic related to AI? Apply for AI Grid and get the opportunity to connect and collaborate with peers and high-level AI experts.</h4>
            <h3 class="head-forth">
                How it works
            </h3>
            <div class="icon-app">
                <div>
                    <img class="icon" v-bind:src="iconReg" />
                    <span class="icon-sub">Create your account <br /> by registering below </span>
                </div>
                <div class="line">
                    <div class="divider"></div>
                </div>
                <div>
                    <img class="icon" v-bind:src="iconApp" />
                    <span class="icon-sub">Fill out the AI Grid <br /> application form </span>
                </div>
                <div class="line">
                    <div class="divider"></div>
                </div>
                <div>
                    <img class="icon" v-bind:src="iconInv" />
                    <span class="icon-sub">You will recieve a feedback by email</span>
                </div>
            </div>
            <div class="lgi-btns">
                <DxButton type="success"
                          @click="register()"
                          width="150px"
                          text="Register here">

                </DxButton>
                <span class="grey-text">or</span>
                <DxButton type="default"
                          @click="signIn()"
                          width="235px"
                          text="Login to your account">

                </DxButton>
            </div>
            <!--<h3 class="head-third">
                Are you ready to mentoring?
                    <DxButton type="success"
                              @click="registerAsMentor()"
                              width="150px"
                              text="Register here">

                    </DxButton>
            </h3>-->
            <h3 class="head-third">About AI Grid</h3>
            <h4>Al Grid is an initiative, funded by the German Federal Ministry of Education and Research, that aims to strengthen synergies and collaborations between young talents in the field of artificial intelligence. </h4>
            <h4>It brings together committed students and young researchers with fresh ideas in a high-value network. </h4>
            <h4>The selected participants „Al Grid Members" will be matched in highly specialised micro-focus groups to share their research and initiate collaborations.</h4>
            <h4> In addition, they will be supported and mentored by renowned Al experts from all over Europe. </h4>
        </div>
        <div class="img-bg">
            <div class="bg-image-sq">
                <img class="bg-image" v-bind:src="bgSq" />
            </div>
        </div>
        <div class="bmbf">
            <img class="" v-bind:src="logoBmbf" />
        </div>
    </div>

    <!--<div class="footerBox">
        <FooterBig></FooterBig>
    </div>-->
</template>
<script>
    import { DxButton } from 'devextreme-vue/button';
    export default {

        name: 'LandingPage',
        components: {
            DxButton,
        },
        data() {
            return {
                iconApp: "~/Images/221219_AI-Grid_Icon_Application.svg",
                iconInv: "~/Images/221219_AI-Grid_Icon_Invitation.svg",
                iconReg: "~/Images/221219_AI-Grid_Icon_Register.svg",
                bgSq: "",
                logoBmbf: "~/Images/Logo_BMBF_en-01.svg",
            }
        },
        mounted() {
        },
        computed: {
        },
        methods: {
            signIn() {
                window.location.href = "Login.aspx" + window.location.search;
            },
            register() {
                window.location.href = "Public/RegisterAsParticipant.aspx"
            },
            registerAsMentor() {
                window.location.href = "Public/RegisterAsMentor.aspx"
            },
        }
    }
</script>
<style scoped>

    /*
        .register {
            margin-top: 10px;
            font-size: 15px;
            font-weight: bold;
            color: white;
            text-align: center;
        }
    */
    .bmbf img {
        block-size: 100px;
    }

    .bmbf {
        margin-top: 50px;
    }

    .divider {
        display: inline-block;
        border-bottom: #999999 1px solid;
        width: 70px;
        color: #999999;
        vertical-align: middle;
    }

    .line {
        align-items: center;
        margin-bottom: 54px;
    }

    span.icon-sub {
        max-width: 160px;
        text-align: center;
    }

    .icon-app {
        margin-bottom: -5px;
        display: flex;
        padding-bottom: 20px
    }

    div.icon-app > div {
        display: grid;
        font-size: 15px;
        color: #a3a3a3;
        font-weight: bold;
        grid-row-gap: 12px;
    }

    .lgi-btns {
        padding-top: 30px;
    }

    span.grey-text {
        font-size: 15px;
        margin: 0px 20px 0px 20px;
        color: #a3a3a3;
        font-weight: bold;
    }

    .lp-page-content {
        display: grid;
        grid-template-columns: 1fr auto;
        box-sizing: border-box;
    }

    .lp-content {
    }

    .img-bg {
        min-width: 345px;
    }



    .head-first {
        font-weight: bold;
        color: #465a64;
    }

    .head-sec {
        color: #00a4e0;
        font-weight: lighter;
        font-size: 22px;
    }

    h4, h3 {
        color: #465a64;
        font-size: 17px;
        font-weight: lighter;
    }

    h4 {
        margin: 0px 0px 10px 0px;
        max-width: 90%;
    }

    h3.head-forth {
        color: #00a4e0;
        margin: 35px 0px 15px 0px;
        font-size: 17px;
        font-weight: bold;
    }

    h3.head-third {
        margin: 35px 0px 10px 0px;
        font-weight: bold;
    }



    .footerBox {
        width: 100vw;
    }


    /* Extra small devices (phones, 1200px and down) */
    @media only screen and (max-width: 1200px) {
        .lp-page-content {
            grid-template-rows: 1fr auto;
            grid-template-columns: 1fr;
        }
    }
    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .line {
            margin-bottom: unset;
        }

        .bmbf {
            text-align: center;
        }



        .lp-page-content {
        }

        .img-bg {
            display: none;
        }

        .img-icon {
            padding: 0;
        }

        .icon-app {
            flex-direction: column;
            justify-items: center;
            padding: 0;
            gap: 20px;
        }

        h3.head-forth {
            text-align: center;
        }

        div.icon-app > div {
            justify-items: center;
            text-align: center;
        }

        .lgi-btns {
            padding-top: 30px;
            padding-right: 0;
            padding-left: 0;
            display: flex;
            flex-direction: column;
        }

            .lgi-btns .dx-button {
                width: auto !important;
            }

        span.grey-text {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }
</style>